export { default as DetailPropertyList } from './DetailPropertyList';
export { default as DetailPropertyListItem } from './DetailPropertyListItem';
